import { testIds } from '../testConfig.utils';

export const QA_SCROLLER_BLOCK = {
  ...testIds('SCROLLER_BLOCK', {}),
};

export const QA_LEAGUE_TABLE = {
  ...testIds('LEAGUE_TABLE', {}),
};

export const QA_LEAGUE_TABLES = {
  ...testIds('LEAGUE_TABLES', {}),
};

export const QA_MATCH_CENTRE_LAYOUT = {
  ...testIds('MATCH_CENTRE_LAYOUT', {}),
};

export const QA_FIXTURE_CARD_SLOTTED = {
  ...testIds('FIXTURE_CARD_SLOTTED', {}),
};

export const QA_MATCH_HEADER = {
  ...testIds('MATCH_HEADER', { IMAGE: 'IMAGE' }),
};

export const QA_PROFILE_HEADER = {
  ...testIds('PROFILE_HEADER', {}),
};

export const QA_MATCH_DAY_HERO = {
  ...testIds('MATCH_DAY_HERO', {}),
};

export const QA_FIXTURES_SUMMARY_BLOCK_MATCH_CARD = {
  ...testIds('FIXTURES_SUMMARY_BLOCK_MATCH_CARD', {}),
};

export const QA_FIXTURE_SUMMARY_BLOCK_LEAGUE_TABLE = {
  ...testIds('FIXTURE_SUMMARY_BLOCK_LEAGUE_TABLE', {}),
};
